import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser'
import App from './App';


const INIT_ID = 'shop-header-component-init';
const INIT_ELEM = document.getElementById(INIT_ID);

Sentry.init({
  dsn: 'https://3d1329337ecc4281931bb5fcf7c3d5e2@sentry.io/5180738',
  whitelistUrls: [
    /https:\/\/shop-common-cdn-prod\.mediazs\.com/,
    /https:\/\/shop-common-cdn-dev\.shpd\.mediazs\.com/
  ],
  environment: process.env.REACT_APP_ENV
});

const componentAvailable = JSON.parse(INIT_ELEM.getAttribute('data-component-available'));

if (componentAvailable) {
  const props = {
    multilanguage: JSON.parse(INIT_ELEM.getAttribute('data-show-multilanguage')),
    availableLanguages: JSON.parse(INIT_ELEM.getAttribute('data-available-languages')),
    helpLink: INIT_ELEM.getAttribute('data-help-link'),
    translations: new Map(Object.entries(JSON.parse(INIT_ELEM.getAttribute('data-translations')))),
    showSearch: JSON.parse(INIT_ELEM.getAttribute('data-show-search')),
    showCart: JSON.parse(INIT_ELEM.getAttribute('data-show-cart')),
    showCategories: JSON.parse(INIT_ELEM.getAttribute('data-show-categories')),
    categories: JSON.parse(INIT_ELEM.getAttribute('data-categories')),
    bonuspointsAvailable: JSON.parse(INIT_ELEM.getAttribute('data-bonuspoints-available')),
    mediaServerUrl: INIT_ELEM.getAttribute('data-media-server-url'),
    bundle: INIT_ELEM.getAttribute('data-bundle'),
    brand: INIT_ELEM.getAttribute('data-brand'),
    exorbyteId: INIT_ELEM.getAttribute('data-exorbyte-id'),
    exorbytePathKey: INIT_ELEM.getAttribute('data-exorbyte-path-key'),
    shippingFeeURL: INIT_ELEM.getAttribute('data-shipping-fee-url'),
    securityIconsURL: INIT_ELEM.getAttribute('data-security-icons-url'),
    cartURL: INIT_ELEM.getAttribute('data-cart-url'),
    viaWebC: JSON.parse(INIT_ELEM.getAttribute('data-via-webc'))
  }


  ReactDOM.render((
    <App {...props} />
  ), INIT_ELEM);
}
